import { Link, useParams } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import Preloading from '../../../components/basics/Preloading';
import DeleteModal from '../../../components/deleteModal/DeleteModal';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";

const UnitMeasurement = () => {
  const { branchId } = useParams();
  const [loading, setLoading] = useState(false);
  const [measurementDimensionTypes, setMeasurementDimensionTypes] = useState([]);
  const [girdData, setGridData] = useState([]);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    title: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: '',
    shortName: '',
    measurementDimensionType: 0,
    description: '',
    enabled: true,
    branchId: branchId,
  });
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const getGridData = async () => {
    const resp = await apiMethod.getUnitMeasurements(filterModel.branchId, filterModel.title, filterModel.size, filterModel.part);
    if (!methods.showApiErrors(resp))
      return false;
    setGridData(resp.data);
  };

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getMeasurementDimensionTypes();
    if (!methods.showApiErrors(resp1))
      return false;
    setMeasurementDimensionTypes(resp1.data);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push('.عنوان باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.branchId) || formModel.branchId === 0) {
      errors.push('.شناسه شعبه باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.measurementDimensionType) || formModel.measurementDimensionType === 0) {
      errors.push('.نوع واحد سنجش باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.shortName)) {
      errors.push('نام اختصار باید مقدار داشته باشد.');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = '';
    formModel.measurementDimensionType = 0;
    formModel.description = '';
    formModel.enabled = true;
    formModel.shortName = '';
    setFormModel({ ...formModel });
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.title = '';
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.total = 0;
    filterModel.parts = 0;
    setFilterModel({ ...filterModel })
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getUnitMeasurementInfo(id);
    if (!methods.showApiErrors(resp))
      return false;

    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.shortName = resp.data.shortName;
    formModel.measurementDimensionType = resp.data.measurementDimensionType;
    formModel.description = resp.data.description;
    formModel.enabled = resp.data.enabled;
    formModel.branchId = resp.data.branchId;
    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const openNewForm = async () => {
    resetForm();
    setShowFormModal(true);
  };

  const createNewItem = async () => {
    if (!validForm())
      return false;

    setLoading(true);
    const resp = await apiMethod.createUnitMeasurement(formModel);
    if (!methods.showApiErrors(resp))
      return false;

    await getGridData();
    setShowFormModal(false);
    setLoading(false);
    return true;
  };

  const selectَItemToDelete = (item) => {
    setFormModel(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeUnitMeasurement(formModel.id);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const closeDelelteModal = () => {
    setShowDeleteModal(false);
  };

  const getmeasurementDimensionName = (id) => {
    const item = measurementDimensionTypes.find(x => x.id === id);
    if (item != null || item != undefined)
      return item.title;
    return "...";
  };

  const searchItem = async () => {
    setLoading(true);
    filterModel.title = document.getElementById('searchInput').value;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const renderProductCategory = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-block'>
              <Link to={`/baseinfo/${branchId}`} className='text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <Link to={`/baseinfo/${branchId}`} className='link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                واحد های سنجش
              </Link>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>واحد های سنجش کالا
                <a href={`/sale/${branchId}/softwareGuide/#section2`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row'>
                  <div className='col-12 col-md-6 col-lg-4'>
                    <label htmlFor="funit" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={filterModel.title}
                        onChange={(e) => {
                          e.target.value = e.target.value.trim();
                          filterModel.title = e.target.value;
                          setFilterModel({ ...filterModel });
                        }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={() => { searchItem() }}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='col-12 col-md-2 col-lg-4'></div>
                  <div className='col-12 col-md-4 col-lg-4'>
                    <div className='createButton'>
                      <button
                        onClick={() => { openNewForm() }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>واحد جدید</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                <table className="table table-striped table-md">
                  <thead className='align-middle'>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">اختصار</th>
                      <th scope="col vertical-center">نوع واحد </th>
                      <th scope="col vertical-center">توضیحات</th>
                      <th scope="col vertical-center">وضعیت</th>
                      <th scope="col vertical-center" width="100px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {girdData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">{index + 1}</th>
                        <td>{item.title}</td>
                        <td>{item.shortName}</td>
                        <td>{getmeasurementDimensionName(item.measurementDimensionType)}</td>
                        <td>{item.description}</td>
                        <td>
                          {item.enabled ? <i className="bi bi-check-square fs-5 activeCheckbox"></i> : <i className="bi bi-x-square fs-5 inActiveCheckbox"></i>}
                        </td>
                        <td>
                          <button
                            onClick={() => editItem(item.id)}
                            className='btn btn-sm btn-outline-purple me-2' type='button'>
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className='btn btn-sm btn-outline-danger' type='button'>
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const formModal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showFormModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-md" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title"> ایجاد / ویرایش واحد سنجش</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => { setShowFormModal(false) }}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label htmlFor="title" className="form-label required-label">عنوان</label>
                  <input type="text" className="form-control" id="title"
                    value={formModel.title}
                    onChange={(e) => { setFormModel({ ...formModel, title: e.target.value }) }}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="shortName" className="form-label required-label">نام اختصار</label>
                  <input type="text" className="form-control" id="shortName"
                    value={formModel.shortName}
                    onChange={(e) => { setFormModel({ ...formModel, shortName: e.target.value }) }}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="pricingType" className="form-label required-label">نوع واحد سنجش</label>
                  <select
                    id="pricingType"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.measurementDimensionType}
                    onChange={(e) => {
                      formModel.measurementDimensionType = parseInt(e.target.value);
                      setFormModel({ ...formModel, measurementDimensionType: formModel.measurementDimensionType })
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {measurementDimensionTypes.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12">
                  <div className="form-check mt-2 mb-2">
                    <input
                      onChange={(e) => {
                        setFormModel({ ...formModel, enabled: e.target.checked })
                      }}
                      checked={formModel.enabled}
                      className="form-check-input" type="checkbox" id="chbenabled" />
                    <label className="form-check-label" htmlFor="chbenabled">
                      فعال
                    </label>
                  </div>
                </div>
                <div className="col-md-12">
                  <label htmlFor="description" className="form-label">توضیحات</label>
                  <textarea type="text" className="form-control" id="description" name="description" rows={3}
                    value={formModel.description}
                    onChange={(e) => { setFormModel({ ...formModel, description: e.target.value }) }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={() => { setShowFormModal(false) }}
              >
                انصراف
              </button>
              <button
                onClick={() => { createNewItem() }}
                type="button" className="btn custome-btn btn-purple w-50">ثبت وذخیره</button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderProductCategory()}
      {showFormModal && formModal()}
      {showDeleteModal &&
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDelelteModal}
          deleteItem={deleteItem}
          text={'واحد'}
        />
      }
    </>
  );
}

export default UnitMeasurement;